/**
 * Returns the current date and time as an ISO 8601 string (e.g. `"2024-03-20T15:30:00.000Z"`).
 */
export const getDateNowISO = () => {
    const d = new Date();

    return d.toISOString();
};
